export default "__VITE_ASSET__7df313bf__"